import { DateTime } from "luxon";

export const sevenDaysFromX = (dateProp) => new Date(dateProp.setDate(dateProp.getDate() + 7));
export const afterSevenDaysToTwoMonthsDaysFromX = (dateProp) => new Date(dateProp.setDate(dateProp.getDate() + 60));

const today = DateTime.now().startOf('day');

export const last_7_days = [
    today.minus({days: 7}),
    today,   
];
export const last_30_days = [
    today.minus({days: 30}),
    today,
];
export const next_7_days = [
    today,
    today.plus({days: 7}),
];
export const next_30_days = [
    today,
    today.plus({days: 30}),
];

const thisMonth = [
    today.startOf('month'),
    today.endOf('month'),
];
const lastMonth = [
    today.minus({months: 1}).startOf('month'),
    today.minus({months: 1}).endOf('month'),
];
const nextMonth = [
    today.plus({months: 1}).startOf('month'),
    today.plus({months: 1}).endOf('month'),
];
const thisYear = [
    today.startOf('year'),
    today.endOf("year"),
];
const lastYear = [
    today.minus({years: 1}).startOf('year'),
    today.minus({years: 1}).endOf('year'),
];
const allTime = [
    today.minus({years: 1}).startOf('year'),
    today, 
];
function getQuarter(flag) {
    var m = flag == 'current'?new Date().getMonth():new Date().getMonth()-3 ;

    var startdate = new Date()
    var enddate = new Date()

    if(m>=0 && m<=2){
        startdate.setMonth(0)
        startdate.setDate(1)
        enddate.setMonth(2)
        enddate.setDate(31)
    }
    else if(m>=3 && m<=5){
        startdate.setMonth(3)
        startdate.setDate(1)
        enddate.setMonth(5)
        enddate.setDate(30)
    }
    else if(m>=6 && m<=8){
        startdate.setMonth(6)
        startdate.setDate(1)
        enddate.setMonth(8)
        enddate.setDate(30)
    }
    else if(m>=9 && m<=11){
        startdate.setMonth(9)
        startdate.setDate(1)
        enddate.setMonth(11)
        enddate.setDate(31)
    }
    return[DateTime.fromJSDate(startdate), DateTime.fromJSDate(enddate)]
  }

export const DateRanges = {
    
    'Last Year': lastYear,
    'Last Month': lastMonth,
    // 'Today': [today, today],
    'This Month': thisMonth,
    // 'Next Month': nextMonth,
    'This Year': thisYear,
    'This Quarter':getQuarter('current'),
    'Last Quarter':getQuarter('last'),
    'Last 30 Days':last_30_days,
    'All Time': allTime
};